import { Agreement } from 'models'

export const getBrandNames = (agreement: Agreement): string => {
  const { scopes = [] } = agreement
  if (!scopes.length) return ''

  const brands = new Set<string>()

  scopes.forEach(scope => {
    scope.filters
      .filter(f => f.type === 'Brands')
      .forEach(f => f.brands.forEach(b => brands.add(b.name)))
  })

  return Array.from(brands).join(',')
}

export const getRemainingBudget = (agreement: Agreement): number => {
  return agreement.budgetRemaining || (agreement.budget - agreement.budgetSpent)
}
